import { Grid, Button, lighten } from "@mui/material";
import { styled } from "@mui/material/styles";
import { COLORS } from "src/_globalStore/redux/reducers/Theme/themeConstants";

export const ButtonsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  gap: "5px",
});

export const ViewOptionButton = styled(Button)({
  maxWidth: "150px",
  padding: "2px 9px",
});

export const Container = styled(Grid)(({ theme }) => ({
  "& .highlighted": {
    // border: `2px solid ${theme.palette.error.light} !important`,
    borderRadius: "3px",
    maxWidth: "calc(100% - 4px)",
    backgroundColor: lighten(COLORS.yellow_gradients.yellow, 0.2),
  },
}));
